import type {
  ILuckyDrawRewardChance,
  LUCKYDRAW_REWARD_TYPE,
} from '@typings/store/luckydraw.interface';

type LuckyDrawSource = {
  itemList?: string[];
  skillList?: string[];
  rewardChanceList?: ILuckyDrawRewardChance[];
};

type SelectedReward = {
  id: string;
  type: LUCKYDRAW_REWARD_TYPE;
};

function inferRewardType(
  id: string,
  itemList: string[],
  skillList: string[],
): LUCKYDRAW_REWARD_TYPE {
  return skillList.includes(id) && !itemList.includes(id) ? 'skill' : 'item';
}

export function selectLuckyDrawReward(
  source: LuckyDrawSource,
): SelectedReward | null {
  const itemList = source.itemList || [];
  const skillList = source.skillList || [];
  const allItems = [...itemList, ...skillList];

  if (allItems.length === 0) return null;

  const validChanceList = (source.rewardChanceList || [])
    .map((reward) => ({
      ...reward,
      chance: Number(reward.chance || 0),
      type: reward.type || inferRewardType(reward.id, itemList, skillList),
    }))
    .filter(
      (reward) => allItems.includes(reward.id) && reward.chance > 0,
    );

  const totalChance = validChanceList.reduce(
    (sum, reward) => sum + reward.chance,
    0,
  );

  if (totalChance > 0) {
    const roll = Math.random() * totalChance;
    let cursor = 0;

    for (const reward of validChanceList) {
      cursor += reward.chance;
      if (roll < cursor) {
        return {
          id: reward.id,
          type: reward.type,
        };
      }
    }
  }

  const pickId = allItems[Math.floor(Math.random() * allItems.length)];
  return {
    id: pickId,
    type: inferRewardType(pickId, itemList, skillList),
  };
}
